var _rect, _circle, _rect2, _circle2, _rect3, _circle3, _rect4, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRiskLabelExample = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 28,
    viewBox: "0 0 459 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 28,
    rx: 14,
    fill: "#F4F5FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14,
    r: 6.5,
    fill: "#EE7E7E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    width: 108,
    height: 28,
    rx: 14,
    fill: "#F4F5FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.5,
    cy: 14,
    r: 6.5,
    fill: "#FFB801"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    width: 108,
    height: 28,
    rx: 14,
    fill: "#F4F5FA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 14,
    r: 6.5,
    fill: "#2DB875"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    width: 108,
    height: 28,
    rx: 14,
    fill: "#F4F5FA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 362.5,
    cy: 14,
    r: 6.5,
    fill: "#B2BCEB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRiskLabelExample);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/risk-label-example.59774b95d6f295dde7104803a57e04f5.svg";